import { ForgotPasswordForm } from '@/components/modules/auth/ForgotPasswordForm'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordForm,
})
